import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as fontawesome from '@fortawesome/free-solid-svg-icons';
import { HeroOverlayService } from '../../../services/hero-overlay.service';
import { SportFilterService } from '../../../services/sport-filter.service';

@Component({
  selector: 'app-header',
  imports: [FontAwesomeModule, RouterModule, NgOptimizedImage],
  template: `
    <header class="fixed inset-x-0 top-0 z-30 h-16">
      <!--
        Background is its own layer so it can fade independently of the nav
        content. bg-background is a CSS custom property, so animating a
        colour with alpha directly is not possible — opacity on a solid layer
        is. Fully opaque on every page except one with a registered hero.
      -->
      <div
        aria-hidden="true"
        class="absolute inset-0 bg-background transition-opacity duration-200"
        [style.opacity]="overlay.opacity()"
      ></div>
      <nav
        class="relative mx-auto flex h-16 max-w-7xl items-center justify-between px-2"
        aria-label="Global"
      >
        <div class="flex lg:flex-1 items-center">
          <a [routerLink]="'/'" class="m-1.5 p-1.5 flex items-center space-x-2">
            <span class="sr-only">Sportilink</span>
            <!--
              Two stacked marks that crossfade: the real artwork, and a masked
              silhouette tinted with the brand colour. Over a hero the
              silhouette shows in secondary; everywhere else the full-colour
              logo is visible, so the artwork is never permanently flattened.
            -->
            <span class="relative inline-block h-8 w-8 flex-shrink-0">
              <img
                class="h-8 w-8 transition-opacity duration-200"
                [class.opacity-0]="onHero()"
                [ngSrc]="
                  'https://dglstorage.com/files/sportilink/images/icon-only.webp'
                "
                alt="Sportilink"
                width="32"
                height="32"
                loading="lazy"
              />
              <span
                aria-hidden="true"
                class="logo-mask pointer-events-none absolute inset-0 bg-secondary transition-opacity duration-200"
                [class.opacity-0]="!onHero()"
              ></span>
            </span>
            <span [class]="wordmarkClass()">Sportilink</span>
          </a>
        </div>
        <div class="flex lg:hidden">
          <button
            type="button"
            [class]="'inline-flex items-center justify-center rounded-md p-2.5 ' + (onHero() ? 'text-secondary' : 'text-accent')"
            (click)="menuOpen.set(true)"
          >
            <span class="sr-only">Open main menu</span>
            <fa-icon
              [class]="'text-lg font-thin ' + (onHero() ? 'text-secondary drop-shadow-md' : 'text-accent')"
              [icon]="fa.faBars"
            ></fa-icon>
          </button>
        </div>
        <div class="hidden lg:flex lg:gap-x-12">
          <!-- <div class="relative">
            <button
              type="button"
              class="flex items-center gap-x-1  font-semibold text-gray-900"
              aria-expanded="false"
            >
              Product
              <svg
                class="size-5 flex-none text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            
          'Product' flyout menu, show/hide based on flyout menu state.

          Entering: "transition ease-out duration-200"
            From: "opacity-0 translate-y-1"
            To: "opacity-100 translate-y-0"
          Leaving: "transition ease-in duration-150"
            From: "opacity-100 translate-y-0"
            To: "opacity-0 translate-y-1"
       
            <div
              class="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 "
            >
              <div class="p-4">
                <div
                  class="group relative flex items-center gap-x-6 rounded-lg p-4  hover:bg-gray-50"
                >
                  <div
                    class="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <svg
                      class="size-6 text-gray-600 group-hover:text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
                      />
                    </svg>
                  </div>
                  <div class="flex-auto">
                    <a href="#" class="block font-semibold text-gray-900">
                      Analytics
                      <span class="absolute inset-0"></span>
                    </a>
                    <p class="mt-1 text-gray-600">
                      Get a better understanding of your traffic
                    </p>
                  </div>
                </div>
                <div
                  class="group relative flex items-center gap-x-6 rounded-lg p-4  hover:bg-gray-50"
                >
                  <div
                    class="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <svg
                      class="size-6 text-gray-600 group-hover:text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
                      />
                    </svg>
                  </div>
                  <div class="flex-auto">
                    <a href="#" class="block font-semibold text-gray-900">
                      Engagement
                      <span class="absolute inset-0"></span>
                    </a>
                    <p class="mt-1 text-gray-600">
                      Speak directly to your customers
                    </p>
                  </div>
                </div>
                <div
                  class="group relative flex items-center gap-x-6 rounded-lg p-4  hover:bg-gray-50"
                >
                  <div
                    class="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <svg
                      class="size-6 text-gray-600 group-hover:text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33"
                      />
                    </svg>
                  </div>
                  <div class="flex-auto">
                    <a href="#" class="block font-semibold text-gray-900">
                      Security
                      <span class="absolute inset-0"></span>
                    </a>
                    <p class="mt-1 text-gray-600">
                      Your customers’ data will be safe and secure
                    </p>
                  </div>
                </div>
                <div
                  class="group relative flex items-center gap-x-6 rounded-lg p-4  hover:bg-gray-50"
                >
                  <div
                    class="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <svg
                      class="size-6 text-gray-600 group-hover:text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </div>
                  <div class="flex-auto">
                    <a href="#" class="block font-semibold text-gray-900">
                      Integrations
                      <span class="absolute inset-0"></span>
                    </a>
                    <p class="mt-1 text-gray-600">
                      Connect with third-party tools
                    </p>
                  </div>
                </div>
                <div
                  class="group relative flex items-center gap-x-6 rounded-lg p-4  hover:bg-gray-50"
                >
                  <div
                    class="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white"
                  >
                    <svg
                      class="size-6 text-gray-600 group-hover:text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                      />
                    </svg>
                  </div>
                  <div class="flex-auto">
                    <a href="#" class="block font-semibold text-gray-900">
                      Automations
                      <span class="absolute inset-0"></span>
                    </a>
                    <p class="mt-1 text-gray-600">
                      Build strategic funnels that will convert
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="grid grid-cols-2 divide-x  bg-gray-50"
              >
                <a
                  href="#"
                  class="flex items-center justify-center gap-x-2.5 p-3  font-semibold text-gray-900 hover:bg-gray-100"
                >
                  <svg
                    class="size-5 flex-none text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm6.39-2.908a.75.75 0 0 1 .766.027l3.5 2.25a.75.75 0 0 1 0 1.262l-3.5 2.25A.75.75 0 0 1 8 12.25v-4.5a.75.75 0 0 1 .39-.658Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  Watch demo
                </a>
                <a
                  href="#"
                  class="flex items-center justify-center gap-x-2.5 p-3  font-semibold text-gray-900 hover:bg-gray-100"
                >
                  <svg
                    class="size-5 flex-none text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  Contact sales
                </a>
              </div>
            </div>
          </div> -->

          <a
            [routerLink]="['/clubs']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Clubs</a
          >
          <a
            [routerLink]="['/coaches']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Coaches</a
          >
          <a
            [routerLink]="['/sponsors']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Sponsors</a
          >
          <a
            [routerLink]="['/match-sessions']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Sessions</a
          >
          <a
            [routerLink]="['/tournaments']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Tournaments</a
          >
          <a
            [routerLink]="['/events']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Events</a
          >
          <a
            [routerLink]="['/venues']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Venues</a
          >
          <a
            [routerLink]="['/marketplace']"
            [queryParams]="{ sportType: sportFilterService.filter() }"
            [class]="linkClass()"
            >Marketplace</a
          >
        </div>
        <div class="hidden lg:flex lg:flex-1 lg:justify-end">
          <a
            href="https://app.sportilink.com"
            [class]="linkClass()"
            >Log in <span aria-hidden="true">&rarr;</span></a
          >
        </div>
      </nav>
      <!-- Mobile menu, show/hide based on menu open state. -->
      <div
        [class.show]="menuOpen()"
        [class.hidden]="!menuOpen()"
        class="lg:!hidden"
        role="dialog"
        aria-modal="true"
      >
        <!-- Background backdrop, show/hide based on slide-over state. -->
        <div class="fixed inset-0 z-10"></div>
        <div
          class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-background px-4 py-4 sm:max-w-sm sm:ring-1 sm:"
        >
          <div class="flex items-center justify-between">
            <a href="/" class="p-1.5 flex items-center space-x-2">
              <!-- <span class="sr-only">Sportilink</span> -->
              <img
                class="h-8 w-auto text-accent"
                src="https://dglstorage.com/files/sportilink/images/icon-only.webp"
                width="32"
                height="32"
                loading="lazy"
                alt="Sportilink"
              />
              <span class="text-2xl font-bold text-accent">Sportilink</span>
            </a>
            <button
              type="button"
              class="rounded-md py-2.5 px-0 text-accent"
              (click)="menuOpen.set(false)"
            >
              <span class="sr-only">Close menu</span>
              <fa-icon
                class="text-lg font-thin text-accent"
                [icon]="fa.faTimes"
              ></fa-icon>
            </button>
          </div>
          <div class="mt-6 flow-root">
            <div class="-my-6 divide-y ">
              <div class="space-y-2 py-6">
                <div class="-mx-3">
                  <!-- <button
                    type="button"
                    class="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5  font-semibold text-gray-900 hover:bg-gray-50"
                    aria-controls="disclosure-1"
                    aria-expanded="false"
                  >
                    Product
                    
                  Expand/collapse icon, toggle classes based on menu open state.

                  Open: "rotate-180", Closed: ""
               
                    <svg
                      class="size-5 flex-none"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button> -->
                  <!-- 'Product' sub-menu, show/hide based on menu state. -->
                  <!-- <div class="mt-2 space-y-2" id="disclosure-1">
                    <a
                      href="#"
                      class="block rounded-lg py-2 pl-6 pr-3  font-semibold text-gray-900 hover:bg-gray-50"
                      >Clubs</a
                    >
                    <a
                      href="#"
                      class="block rounded-lg py-2 pl-6 pr-3  font-semibold text-gray-900 hover:bg-gray-50"
                      >Sessions</a
                    >
                    <a
                      href="#"
                      class="block rounded-lg py-2 pl-6 pr-3  font-semibold text-gray-900 hover:bg-gray-50"
                      >Tournaments</a
                    >
                    <a
                      href="#"
                      class="block rounded-lg py-2 pl-6 pr-3  font-semibold text-gray-900 hover:bg-gray-50"
                      >About Us</a
                    >
                  </div> -->
                </div>
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/clubs']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Clubs</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/coaches']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Coaches</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/sponsors']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Sponsors</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/match-sessions']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Sessions</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/tournaments']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Tournaments</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/events']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Events</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/venues']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Venues</a
                >
                <a
                  (click)="menuOpen.set(false)"
                  [routerLink]="['/marketplace']"
                  [queryParams]="{ sportType: sportFilterService.filter() }"
                  class="-mx-3 block rounded-lg px-4 py-2  font-semibold text-accent hover:bg-gray-50"
                  >Marketplace</a
                >
              </div>
              <div class="py-6">
                <a
                  href="https://app.sportilink.com"
                  class="-mx-3 block rounded-lg px-4 py-2.5  font-semibold text-accent hover:bg-gray-50"
                  >Log in</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  `,
})
export class HeaderComponent {
  menuOpen = signal(false);
  fa = fontawesome;

  readonly overlay = inject(HeroOverlayService);

  /** True while the header is sitting over a hero rather than page background. */
  readonly onHero = computed(() => this.overlay.opacity() < 0.5);

  readonly linkClass = computed(
    () =>
      'font-semibold transition-colors ' +
      (this.onHero() ? 'text-secondary drop-shadow-md' : 'text-accent')
  );

  readonly wordmarkClass = computed(
    () =>
      'text-2xl font-bold transition-colors ' +
      (this.onHero() ? 'text-secondary drop-shadow-md' : 'text-accent')
  );

  constructor(public sportFilterService: SportFilterService) {}
}
